import { Component, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SharedVariablesService } from '../../services/shared-variables.service';
import { FormatDatePipe } from '../../shared/pipes/format-date.pipe';
import { TippyDirective } from '../../shared/tippy.directive';

interface IBuildInfo {
  version: string;
  buildDate: string | number;
}

@Component({
  selector: 'app-info',
  imports: [FormatDatePipe, TippyDirective],
  templateUrl: './app-info.component.html',
  styleUrl: './app-info.component.scss',
})
export class AppInfoComponent {
  private sharedVars = inject(SharedVariablesService);

  build: IBuildInfo = environment.about;
  apiBuild = this.sharedVars.getVar<IBuildInfo>('apiVersion');

  tippyOptions = {
    theme: 'dropdown',
    interactive: true,
    trigger: 'click',
    appendTo: document.body,
    placement: 'bottom-end',
    offset: [0, 6]
  };
}
